// extracted by mini-css-extract-plugin
export default {"root":"Ms0xgd2TOWMlsMFidz6l","body":"S1YhXCsp18FGl70yfTQu","image":"sAZmPLNc2E1SFbtwoi_n","copy":"WfzJxKx3eqFvOn3MLeyL","footer":"wQ8EIMSIpX6GaOUKNu4A"};